import commonState from '@/common/store/state'

import { entity, entitySingle } from '../entity'

const customState = {
  entity,
  entitySingle
}

export default Object.assign(
  {},
  commonState,
  customState
)
